( function( $ ) {
	$( document ).ready( function() {
		$('[data-toggle="popover"]').popover();
		$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
			var $activeTab = $(e.target).attr('href'); // newly activated tab
			$($activeTab).focus();
		} );
	} );
} )( jQuery );
